import { createRoute } from '@tanstack/react-router';
import { IconStack2 } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { PROFILES, SERVICE_DEFS, SERVICE_TASKS } from './fixtures';
import { ServiceList } from './ServiceList';
import { Catalog } from './Catalog';
import { Price } from './Price';
import { PRICE_CUS, PRICE_LINES, PRICE_ROUTES, PRICE_SUR } from './priceFixtures';
import { Norms } from './Norms';
import { NORM_LOG, NORM_ROWS } from './normFixtures';
import { SVC_CATALOG, SVC_CODES, SVC_QA } from './catalogFixtures';
import { svcCatalogApiRoute } from './apiRoute';

// H-04b3: Định mức (/ezy/service-norms) — màn tiền, sau quyền money (?money=view).
// H-04b: Biểu giá dịch vụ (/ezy/service-price).
// H-04a: Danh mục dịch vụ (/ezy/service-catalog). Biểu giá · Định mức (H-04b/c) thêm sau.
// H-03a: Dịch vụ — danh sách việc (Mint-Service). Chi tiết / iPad / điện thoại (H-03b), Danh mục · Biểu giá · Định mức (H-04) thêm sau.
const services: EzyModule = {
  nav: { key: 'services', label: 'Dịch vụ', icon: IconStack2, section: 'Vận hành', items: [{ key: 'service-tasks', label: 'Dịch vụ', to: '/ezy/service-tasks' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/service-tasks', component: ServiceList }),
    createRoute({ getParentRoute: () => parent, path: '/service-catalog', component: Catalog }),
    createRoute({ getParentRoute: () => parent, path: '/service-price', component: Price }),
    createRoute({ getParentRoute: () => parent, path: '/service-norms', component: Norms }),
  ],
  api: { svcCatalog: svcCatalogApiRoute },
  fixtures: (register) => {
    register('svcDef', SERVICE_DEFS);
    register('svcTask', SERVICE_TASKS);
    register('svcProfile', PROFILES);
    register('svcCatalog', SVC_CATALOG);
    register('svcCode', SVC_CODES);
    register('svcQa', SVC_QA);
    register('priceLine', PRICE_LINES);
    register('priceCus', PRICE_CUS);
    register('priceSur', PRICE_SUR);
    register('priceRoute', PRICE_ROUTES);
    register('normRow', NORM_ROWS);
    register('normLog', NORM_LOG);
  },
};
export default services;
